import React, { useRef, useState, useEffect } from 'react';
import lottie from 'lottie-web';
var Lottie = function (_a) {
    var data = _a.data, loop = _a.loop, paused = _a.paused, segments = _a.segments, _b = _a.height, height = _b === void 0 ? 100 : _b, _c = _a.width, width = _c === void 0 ? 100 : _c, onEnd = _a.onEnd;
    var container = useRef(null);
    var _d = useState(null), animation = _d[0], setAnimation = _d[1];
    useEffect(function () {
        if (!animation)
            return;
        if (paused) {
            animation.stop();
        }
        else {
            animation.play();
        }
    }, [paused]);
    useEffect(function () {
        var options = {
            container: container.current,
            animationData: data,
            loop: loop || false,
            autoplay: !paused,
        };
        var _animation = lottie.loadAnimation(options);
        if (segments) {
            _animation.playSegments(segments);
        }
        if (typeof onEnd === 'function') {
            _animation.addEventListener('complete', onEnd);
        }
        setAnimation(_animation);
        return function () {
            _animation.destroy();
        };
    }, []);
    var style = {
        width: width + "px",
        height: height + "px",
        overflow: 'hidden',
        margin: '0 auto',
        outline: 'none',
    };
    return React.createElement("div", { ref: container, style: style });
};
export default Lottie;
